import KycProfile from './kyc-profile';

export default KycProfile;
